import cc from "classcat"
import QuoteIcon from "images/quote.svg"

const Quote = ({ content, hasTitle = true, textStyle = "dark" }) => {
  const { title, text, picture } = content
  return (
    <div className="relative max-w-screen-xl">
      <div className="relative mb-6 ml-12 mr-10 space-y-6">
        <blockquote className="relative m-0">
          <QuoteIcon className="absolute -left-12 -top-1 h-8 w-8 rotate-180 transform text-white" />
          <QuoteIcon className="absolute -right-4 bottom-0 h-8 w-8 rotate-180 transform text-white" />
          <div className="relative max-w-3xl text-left font-display">
            <p
              className={cc([
                "text-xl",
                textStyle === "light" ? "text-zinc-200" : "text-zinc-800",
              ])}
            >
              {text}
            </p>
          </div>
        </blockquote>
        <div className="flex space-x-6">
          <img className="h-28 w-28 rounded-full" src={picture} alt="" />
          <div className="flex items-center justify-start">
            <div className="md:items-left max-w-3xl md:mt-0 md:flex">
              {hasTitle ? (
                <div
                  className={cc([
                    "relative text-left font-display text-base",
                    textStyle === "light" ? "text-zinc-200" : "text-zinc-800",
                  ])}
                >
                  {title}
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Quote
